// btn-scroll-down

document.addEventListener('DOMContentLoaded', () => {
    const btnScrollDown = document.querySelector("#btn-scroll-down");
    if (!btnScrollDown) return;

    btnScrollDown.addEventListener("click", function () {
        const parent = btnScrollDown.closest(".container--highlight");
        if (!parent) return;

        const nextElement = parent.nextElementSibling;
        if (!nextElement) return;

        const isMobile = window.matchMedia("(max-width: 1023px)").matches;

        if (!isMobile) {
            // Desktop normal
            nextElement.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
            return;
        }

        // Mobile / tablet offset 66px
        const offset = 66;
        const elementPosition = nextElement.getBoundingClientRect().top + window.scrollY;
        const targetPosition = elementPosition - offset;

        window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
        });
    });
});